"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CmsBannerUrlEditor = /** @class */ (function (_super) {
    __extends(CmsBannerUrlEditor, _super);
    function CmsBannerUrlEditor(props) {
        return _super.call(this, props) || this;
    }
    CmsBannerUrlEditor.prototype.getPriorityAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-" + i,
            });
        }
        return _ret;
    };
    CmsBannerUrlEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.setState({
                title: this.props.record.title,
                url_template: this.props.record.route_template,
                is_locked: this.props.record.is_locked,
                brand_id: this.props.record.brand_id,
                brand_title: this.props.record.brand_title,
                priority_key: this.props.record.priority,
                priority_val: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-" + this.props.record.priority,
                priority_avail: this.getPriorityAvail()
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Редактирование маршрута баннера"]);
            });
        }
        else {
            this.setState({
                title: "",
                url_template: "",
                is_locked: false,
                brand_id: -1,
                brand_title: "",
                priority_key: 1,
                priority_val: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-" + 1,
                priority_avail: this.getPriorityAvail(),
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание маршрута баннера"]);
            });
        }
        this.doReSetRules();
    };
    CmsBannerUrlEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            url_template_rules: { isError: false },
            brand_rules: { isError: false },
            priority_rules: { isError: false },
        });
    };
    CmsBannerUrlEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                title: this.state.title,
                route_template: this.state.url_template,
                is_locked: this.state.is_locked,
                key: this.props.record.key,
                priority: this.state.priority_key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Маршрут баннера изменен!");
            });
        }
    };
    CmsBannerUrlEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.url_template) || (this.state.url_template.length === 0)) {
            this.setState({ url_template_rules: { isError: true, errorMessage: "Поле [шаблон маршрута] не заполнено!" } });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" }
            });
            return false;
        }
        if ((this.state.priority_key <= 0) || (this.state.priority_val.length === 0)) {
            this.setState({
                priority_rules: { isError: true, errorMessage: "Поле [приоритет] не выбрано!" }
            });
            return false;
        }
        return true;
    };
    CmsBannerUrlEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                title: this.state.title,
                route_template: this.state.url_template,
                is_locked: this.state.is_locked,
                brand_id: this.state.brand_id,
                priority: this.state.priority_key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Маршрут баннера добавлен!");
            });
        }
    };
    CmsBannerUrlEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CmsBannerUrlEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить маршрут баннера";
        }
        else {
            return "Изменить маршрут баннера";
        }
    };
    CmsBannerUrlEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false },
                    });
                }, items: this.props.brandsList, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Приоритет:", placeholder: "Выберите приоритет" }, value: { key: this.state.priority_key, value: this.state.priority_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        priority_key: newVal.key,
                        priority_val: newVal.value,
                        priority_rules: { isError: false }
                    });
                }, items: this.state.priority_avail, required: true, rules: this.state.priority_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Шаблон маршрута:", placeholder: "Введите шаблон маршрута" }, value: this.state.url_template, onValueChanged: function (newVal) {
                    _this.setState({
                        url_template: newVal,
                        url_template_rules: { isError: false }
                    });
                }, required: true, rules: this.state.url_template_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Маршрут баннера заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CmsBannerUrlEditor;
}(React.Component));
exports.default = CmsBannerUrlEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_banners/ui/component/CmsBannerRouteEditor.tsx
// module id = 2385
// module chunks = 0